import React from "react";
import { AdminReferenceResponseDetailView } from "./view";
import { styles } from "./styles";

export const AdminReferenceResponseDetail = props => (
  <AdminReferenceResponseDetailView {...props} styles={styles} />
);
